import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-2">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500">编辑部精心挑选，不容错过的优质漫画作品</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {cardItems.map((card) => (
              <article
                key={card.id}
                className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer"
              >
                <div className="aspect-[3/2] overflow-hidden bg-background-200">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center justify-between mb-2 flex-wrap gap-2">
                    <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full">
                      {card.tag}
                    </span>
                    <span className="text-xs font-semibold text-primary-600">{card.stat}</span>
                  </div>
                  <h3 className="font-heading text-base font-bold text-foreground-900 mb-1.5">
                    {card.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {card.description}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}